import { Component, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from 'src/core/http/authentication.service';
import { BaseComponent } from '../base.component';
import { AppService } from 'src/core/services/app-service';
import { take, finalize, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-dialog-change-instance',
  templateUrl: './dialog-change-instance.component.html',
  styleUrls: ['./dialog-change-instance.component.scss']
})

export class DialogChangeInstanceComponent extends BaseComponent implements OnInit {

  isLoading = false;
  errorMessages = [];

  currentAppInstance = null;
  userInfo = null;
  twoColumnsSelectionLimit = 12; //Swith to two columns layout selection (for AppInstances) when the total number of AppInstaces is greater than the limit.

  constructor(
    public dialogRef: MatDialogRef<DialogChangeInstanceComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public appService: AppService,
    public authenticationService: AuthenticationService,
    ) {
      super(authenticationService);
  }


  ngOnInit(): void {
    this.userInfo = this.authenticationService.userInfo;    
    // this.userInfo.AppInstances = this.userInfo.AppInstances.concat(this.userInfo.AppInstances).concat(this.userInfo.AppInstances).concat(this.userInfo.AppInstances).concat(this.userInfo.AppInstances);

    if (this.userInfo!= null
      && this.userInfo.AppInstances != null
      && this.userInfo.AppInstances.length > 0
      && this.userInfo.AuthResult != null
      && this.userInfo.AuthResult.Instance != null) {
        const currentInstanceId = this.userInfo.AuthResult.Instance.Id;
        const instances = this.userInfo.AppInstances.filter(item => item.AppInstanceGroupId === currentInstanceId);
        if (instances && instances.length > 0) {
          this.currentAppInstance =  instances[0];
        }
    }
  }


  appInstSelected(appInstObj) {
    this.isLoading = true;

    const accessToken = this.userInfo != null && this.userInfo.AuthResult != null ? this.userInfo.AuthResult.AccessToken : null;
    this.authenticationService.changeInstance(appInstObj.AppInstanceGroupId, accessToken)
    .pipe(
      takeUntil(this.unsubscribe),
      finalize(() => {
        // this.isLoading = false;
      })
    )
    .subscribe(
      (rawResult: any) => {
        if (rawResult) {
          if (rawResult.State) {
              this.storeUserInfoAndReloadPage(rawResult.Data);
          } else {
            if (rawResult.Messages && rawResult.Messages.length > 0) {
              this.errorMessages = rawResult.Messages;
            } else {
              this.errorMessages = ['An unexpected error occured!'];
            }
            this.isLoading = false;
          }
        } else {
          this.errorMessages = ['An unexpected error occured!'];
          this.isLoading = false;
        }
      },
      error => {
        this.isLoading = false;
      }
      // () => {
      //   this.isLoading = false;
      // }
    );
  }


  storeUserInfoAndReloadPage(loggedinUser) {
    // switch (environment.storageType) {
    //   case 'sessionStorage':
    //     sessionStorage.setItem('LOGGEDIN_USER', JSON.stringify(loggedinUser));
    //     break;
    //   case 'localStorage':
    //   default:
    //     localStorage.setItem('LOGGEDIN_USER', JSON.stringify(loggedinUser));
    //     break;
    // }
    this.authenticationService.userInfo = loggedinUser;
    window.location.reload();
  }


  closeDialog() {
    this.dialogRef.close();
  }

}
